<template>
  <div class="entity-workflow-selected-single">
    <div :class="{'selected': showSelected}" class="entity-workflow-selected-single__item">
      <i v-if="showSelected" class="ddi ddi-check-thick" />
      <div class="title-and-desc">
        <p><strong>{{workflow.name}}</strong></p>
        <p class="small">{{workflow.description}}</p>
      </div>
      <div class="attributes">
        <div>
          <status-chicklet
            v-for="status in workflow.listStatuses" 
            :key="status.id" 
            :status="status" 
          />
        </div>
        <div v-if="$permissions.jobsFeatureEnabled && hasJobs(workflow)" class="jobs">
          <chicklet
            v-for="job in workflow.listJobs" 
            :key="job.id" 
            :title="job.name" 
            is-uppercase
            size="tiny"
          >
            <span>{{job.name}}</span>
          </chicklet>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IWorkflowForSelection } from '@/api/types/response.types'

/* API */

export default defineComponent({
  name: 'EntityWorkflowSelectedSingle',

  props: {
    workflow: {
      type: Object as () => IWorkflowForSelection,
      required: true,
    },
    showSelected: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    hasJobs(workflow: IWorkflowForSelection): boolean {
      return workflow.listJobs.length > 0
    },
  },
})
</script>

<style lang="scss">
.entity-workflow-selected-single {
  margin-bottom: 20px;
  padding-top: 5px;
  box-shadow: inset 0 2px 5px $color--gray-30;
  border: $border--solid-light;
  background-color: var(--color-background-primary);

  &__item {
    position: relative;
    display: flex;
    flex-direction: column;
    @include flex-row-horizontal-spacing(10px);
    padding: 16px 0 16px 40px;
    border: $border--solid-light;
    margin: 10px;
    border-radius: 8px;
    cursor: pointer;

    .ddi-check-thick {
      position: absolute;
      left: 6px;
      top: 16px;
      color: $color--blue-60;
      font-size: 28px;
    }

    .attributes {
      display: flex;
      flex-direction: column;
      margin-top: 10px;

      > div {
        display: flex;
        @include flex-row-horizontal-spacing(4px);
        @include flex-row-vertical-spacing-on-wrap(4px);

        &.jobs {
          margin-top: 10px;
        }

        @include media-breakpoint-down(md) {
          width: 100%;
        }
      }
    }

    @include media-breakpoint-down(md) {
      flex-direction: column;
      @include flex-column-vertical-spacing(8px);
    }
  }
}
</style>
